// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"b02f39c6","209":"ff20ef9a","856":"68f7cdfa"}[chunkId] + ".chunk.css";
};